import mod from "-!./TheProduct.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./TheProduct.js?vue&type=script&lang=js&external"